<template>
	<va-card title="Image Processesor activity">
	
		<ul class="console" v-chat-scroll="{always: true, smooth: true, scrollonremoved:true}">
			
			<li class="line-item" v-if="messages.length < 1"> Listening for process updates .... </li>

			<li class="line-item" v-for="(queue_object, index) in messages">
			    <strong v-if="queue_object.task_id != 'null'">{{ queue_object.task_id }}:</strong> {{ queue_object.message }}
			</li>

		</ul>


	</va-card>
</template>
<script>
	
	import Table from '../../ui/table/Table';
	import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
	import { debounce } from 'lodash'
	export default {
		components: {
			Table,
		},
		props: [],
		data () {
			return {
				loading: false,
			}
		},
		computed: {

			...mapState({
				messages: state => state.imageAnalyst.queue_messages,
			})

		},
		methods: {

			...mapActions({
        		connect_queue: 'connectProccessTunnel'
      		}),

		},
		mounted(){
			this.connect_queue()
		}
	}
</script>
<style lang="scss" scoped>

.data-table-server-pagination---avatar {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	transform: scale(1.4);
}

ul.console {
    padding: 1rem;
    background: #000;
    max-height: 80vh;
    overflow: auto;
    color: #1daf24;
    border-radius: 0.25rem;
}

li.line-item {
    font-family: monospace;
}

</style>
